export const money = (n) =>
  "$" + (n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const initials = (name = "") =>
  name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.floor(h / 24);
  if (days < 30) return `${days}d ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export const dateStr = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export const sentimentColor = {
  positive: "text-success bg-success/10 border-success/20",
  neutral: "text-amber-600 bg-amber-50 border-amber-200",
  negative: "text-destructive bg-destructive/10 border-destructive/20",
};

export const tierColor = {
  Bronze: "bg-orange-100 text-orange-700 border-orange-200",
  Silver: "bg-slate-100 text-slate-700 border-slate-200",
  Gold: "bg-amber-100 text-amber-800 border-amber-200",
  Platinum: "bg-violet-100 text-violet-700 border-violet-200",
};

export const stageLabel = {
  lead: "Lead",
  reservation_confirmed: "Upcoming",
  checked_in: "In-house",
  checked_out: "Past guest",
  no_show: "No-show",
  reservation_canceled: "Canceled",
};

export const stageColor = {
  lead: "bg-blue-50 text-blue-700 border-blue-200",
  reservation_confirmed: "bg-indigo-50 text-indigo-700 border-indigo-200",
  checked_in: "bg-emerald-50 text-emerald-700 border-emerald-200",
  checked_out: "bg-slate-100 text-slate-600 border-slate-200",
  no_show: "bg-destructive/10 text-destructive border-destructive/20",
  reservation_canceled: "bg-destructive/10 text-destructive border-destructive/20",
};

export const consentColor = {
  opted_in: "text-success bg-success/10 border-success/20",
  opted_out: "text-destructive bg-destructive/10 border-destructive/20",
  unknown: "text-muted-foreground bg-secondary border-border",
};

export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "es", name: "Spanish", native: "Español" },
  { code: "fr", name: "French", native: "Français" },
  { code: "de", name: "German", native: "Deutsch" },
  { code: "it", name: "Italian", native: "Italiano" },
  { code: "pt", name: "Portuguese", native: "Português" },
  { code: "zh", name: "Chinese (Simplified)", native: "中文" },
  { code: "ja", name: "Japanese", native: "日本語" },
  { code: "ar", name: "Arabic", native: "العربية" },
];

export const langLabel = (code) => {
  const l = LANGUAGES.find((x) => x.code === code);
  return l ? l.native : (code || "").toUpperCase();
};
